import Phaser from "phaser";
import LoadingScene from "@/dailyGames/Cooking/scenes/LoadingScene";
import QuestionScene from "@/dailyGames/Cooking/scenes/QuestionScene";
import PlayScene from "@/dailyGames/Cooking/scenes/PlayScene";
import AnsCorrectPlayScene from "@/dailyGames/Cooking/scenes/AnsCorrectPlayScene";
import AnsWrongPlayScene from "@/dailyGames/Cooking/scenes/AnsWrongPlayScene";
import BossScene from "@/dailyGames/Cooking/scenes/BossScene";
import LandingScene from "@/dailyGames/Cooking/scenes/LandingScene";
import Settings from "@/dailyGames/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      PlayScene,
      AnsCorrectPlayScene,
      AnsWrongPlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
